import "./InternalImageSliderSelector.scss"
import React, {useEffect, useState} from "react";
import {HttpClient} from "../../../service/httpClient/HttpClient";
import FileManagerSelector from "../../../pages/fileManager2/selector/FileManagerSelector";
import {FileManagerTypes} from "../../../component/fileManager/FileManager";
import {changeContent, EditorItemType, prepareEditorItem} from "../RaikoCustomEditor2";
import thumbnail from "../image/Images-cuate.svg";
import {
    DialogSize, Fancybox,
    RaikoConfirmDialog,
    RaikoDefaultDialogPage, RaikoSectionContainer,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";

export default function InternalImageSliderSelector(
    {
        value = [],
        priority,
        editorValue,
        setEditorValue,
        bucketId = FileManagerTypes.POST_IMAGES.id,
        uid
    }) {

    const [items, setItems] = useState([])

    function prepareSliderItem(url, id) {
        return {
            url,
            id: id
        };
    }

   /* useEffect(() => {

        if (typeof value !== 'undefined' && value.length > 0) {
            setItems([])
            value.map(async (item, index) => {
                let url = item.url;

                if (typeof url === "undefined" || url.length === 0) {
                    url = await new HttpClient(
                        {},
                        "application/json",
                        process.env.REACT_APP_BASE_URL
                    )
                        .get(
                            `files/${item}/urls/public`
                        ).then(res => res.downloadUrl)
                }

                setItems(prev => [
                    ...prev,
                    prepareSliderItem(url, item)
                ])
            })
        } else
            setItems([])

    }, [value])*/


    useEffect(() => {
        let cancelled = false;

        async function syncItems() {
            const ids = Array.isArray(value) ? value : [];

            // 1) یک Map از آیتم‌های فعلی بساز برای lookup سریع
            const existing = new Map(items.map(it => [it.id, it]));

            // 2) فقط برای idهایی که نداریم fetch بزن
            const missingIds = ids.filter(id => !existing.has(id));

            if (missingIds.length > 0) {
                const client = new HttpClient({}, "application/json", process.env.REACT_APP_BASE_URL);

                // موازی ولی کنترل‌شده
                const fetched = await Promise.all(
                    missingIds.map(async (id) => {
                        const url = await client.get(`files/${id}/urls/public`).then(res => res.downloadUrl);
                        return { id, url };
                    })
                );

                if (cancelled) return;

                // به existing اضافه کن
                fetched.forEach(it => existing.set(it.id, it));
            }

            if (cancelled) return;

            // 3) خروجی نهایی را دقیقاً به ترتیب value بچین
            const ordered = ids
                .map(id => existing.get(id))
                .filter(Boolean);

            setItems(ordered);
        }

        syncItems();

        return () => {
            cancelled = true;
        };
// نکته مهم: items را از dependency حذف نکنیم؟ پایین توضیح دادم
    }, [value]);



    const [galleryDialogOpenState, setGalleryDialogOpenState] = useState(false);

    function handleOpenFileManager() {
        setGalleryDialogOpenState(true)
    }

    function checkNotExistItem(id) {
        let exist = false
        items.map((item) => {
            if (item.id === id)
                exist = true
        })


        return !exist
    }

    /*function handleSelectImage(id, url) {
        if (checkNotExistItem(id)) {
            const _items = items
            _items.push(prepareSliderItem(url, id))

            setItems(_items)

            const ids = []
            _items.map(item => {
                ids.push(item.id)
            })

            changeContent(
                editorValue,
                setEditorValue,
                prepareEditorItem(
                    ids
                    , EditorItemType.IMAGE_SLIDER),
                priority)
        } else {
            showWarningMessage("تصویر انتخابی از قبل انتخاب شده است.")
        }
    }*/

    function handleSelectImage(id, url) {
        // به items کاری نداشته باش
        if (!value.includes(id)) {
            const ids = [...value, id]; // value همان ids است که از parent می‌آید
            changeContent(
                editorValue,
                setEditorValue,
                prepareEditorItem(ids, EditorItemType.IMAGE_SLIDER),
                priority
            );
        } else {
            showWarningMessage("تصویر انتخابی از قبل انتخاب شده است.");
        }
    }


    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(-1);

    function handleDeleteItem() {
        const _items = items
        const ids = []
        setItems([])

        _items.map((item, index) => {
            if (item.id !== selectedItemId) {
                ids.push(item.id)
                setItems(prev => [
                    ...prev,
                    prepareSliderItem(item.url, item.id)
                ])
            }
        })


        changeContent(
            editorValue,
            setEditorValue,
            prepareEditorItem(ids, EditorItemType.IMAGE_SLIDER,uid),
            priority)


        setConfirmDialogOpenState(false)
        setSelectedItemId(-1)
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={_ => {
                    setGalleryDialogOpenState(false)
                }}
                open={galleryDialogOpenState}
                dialogSize={DialogSize.LARGE}
                pageTitle={"تصویر مورد نظر خود را انتخاب نمایید."}
            >
                <FileManagerSelector
                    setOpenDialog={setGalleryDialogOpenState}
                    bucketId={bucketId}
                    setSelectedFileUrl={handleSelectImage}
                />

            </RaikoDefaultDialogPage>

            <RaikoConfirmDialog
                openConfirmDialog={confirmDialogOpenState}
                cancelAction={_ => setConfirmDialogOpenState(false)}
                doAction={handleDeleteItem}
                pageTitle={"حذف آیتم"}
                warningDescription={""}
            />

            <div className={"baseInternalImageSliderSelector"}>

                <RaikoSectionContainer
                    title={"اسلایـدر"}
                    subTitle={"تصویر های انتخاب شده در این قسمت به صورت اسلایدر در جزئیات مقاله به نمایش درخواهد آمد."}
                    actionButtonTitle={"افزودن تصویر"}
                    hasActionButton
                    actionButtonOnclick={handleOpenFileManager}
                >
                    {
                        items && items.length > 0 ?
                            <div className={"baseInternalImageSliderSelector"}>

                                <Fancybox
                                    options={{
                                        Carousel: {
                                            infinite: false,
                                        },
                                    }}
                                >

                                    {

                                        items.map((item, index) => {
                                            return <div className={"sliderImageItemsContainer"} key={item.url}>
                                                <img src={item.url} alt=""/>
                                                <div className={"sliderImageItemAccessContainer"}>

                                                    <a href={item.url} data-fancybox={`gallery-${index}`} data-caption={item.id}>
                                                        <div className={"zoom_icon iconContainer"}/>
                                                    </a>

                                                    <div className={"icTrash iconContainer"}
                                                         onClick={_ => {
                                                             setSelectedItemId(item.id)
                                                             setConfirmDialogOpenState(true)
                                                         }}/>

                                                </div>
                                            </div>
                                        })
                                    }

                                    <div
                                        className={"addNewImageCardContainer"}
                                        onClick={_ => {
                                            setGalleryDialogOpenState(true)
                                        }}>
                                        <span>تصویر جدید</span>
                                    </div>

                                </Fancybox>
                            </div>
                            :
                            <div
                                className={"notFoundItemsInSliderContainer"}
                                onClick={handleOpenFileManager}
                            >

                                <img src={thumbnail} alt=""/>
                                <span>برای انتخاب اولین تصویر اسلایدر کلیک نمایید.</span>
                            </div>
                    }
                </RaikoSectionContainer>
            </div>
        </>

    )
}
